import { useEffect, useState } from "react";
import { NewsletterDialog } from "./NewsletterDialog";

const STORAGE_KEY = "hidnstock-newsletter-popup-seen";
const DELAY_MS = 4000;

export const NewsletterPopup = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(STORAGE_KEY)) return;
    const timer = setTimeout(() => {
      setOpen(true);
      localStorage.setItem(STORAGE_KEY, "1");
    }, DELAY_MS);
    return () => clearTimeout(timer);
  }, []);

  return <NewsletterDialog open={open} onOpenChange={setOpen} />;
};
